import { GetPendingDownloadRequests } from '@/connection/content/videos';
import { ContentReducerCreator } from '../types';

const loadPendingDownloadsReducer = (create: ContentReducerCreator) => {
  return create.asyncThunk(
    async (channel: number) => {
      return await GetPendingDownloadRequests(channel);
    },
    {
      pending: (state) => {
        state.loadingContent = true;
      },
      fulfilled: (state, action) => {
        state.pendingDownloads = action.payload;
      },
      settled: (state) => {
        state.loadingContent = false;
      },
    }
  );
};

export default loadPendingDownloadsReducer;
